import React, {memo} from 'react';
import PropTypes from 'prop-types';
import SpaceSettingApiService from '@/modules/spacesSetting/services/SpaceSettingApiService';
import {useQuery} from 'react-query';
import Text from 'antd/es/typography/Text';
import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';

const UserSpace = ({space}) => {

  const {data: nameSpace} = useQuery(['user-space', space], async () => {
    const {data} = await SpaceSettingApiService.getOne(space);
    return data;
  });

  const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;

  return (
    !nameSpace ? <Spin indicator={antIcon}/> :
      <Text>{nameSpace?.name}</Text>
  );
};

UserSpace.propTypes = {
  space: PropTypes.string
};

export default memo(UserSpace);

export const renderUserSpace = (space) => {
  return (
    <UserSpace space={space}/>
  );
};
